import axios from "axios";
import {
  SELLER_CONTACT_LOAD_ATTEMPT,
  SELLER_CONTACT_LOAD_SUCCESS,
  SELLER_CONTACT_LOAD_FAILED,
  ///////////////////////
  SELLER_CONTACT_SAVE_ATTEMPT,
  SELLER_CONTACT_SAVE_SUCCESS,
  SELLER_CONTACT_SAVE_FAILED,
} from "../types/sellerContactTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: SELLER_CONTACT_LOAD_ATTEMPT };
}

export function success(data) {
  return { type: SELLER_CONTACT_LOAD_SUCCESS, data };
}

export function failed(error) {
  return { type: SELLER_CONTACT_LOAD_FAILED, error };
}

export function saving() {
  return { type: SELLER_CONTACT_SAVE_ATTEMPT };
}

export function saveSuccess(data) {
  return { type: SELLER_CONTACT_SAVE_SUCCESS, data };
}

export function saveFailed(error) {
  return { type: SELLER_CONTACT_SAVE_FAILED, error };
}

export const loadItem = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "sellercontact", {
      params: { id: data.user_id },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(failed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};

export const updateItem = (data: Object) => async (dispatch) => {
  dispatch(saving());
  try {
    const response = await axios.put(
      url_api + "sellercontact",
      {
        id: data.user_id,
        email: data.email,
        phone: data.phone,
        chat: data.chat,
        whatsapp: data.whatsapp,
      },
      { headers: { Authorization: `Bearer ${data.token}` } }
    );

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(saveSuccess(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(saveFailed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(saveFailed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
